import type { EntityType } from "types/common.types"

export const getEntityHref = (
  entityType: EntityType,
  entityId: number,
  baseOrgURL: string,
) => {
  switch (entityType) {
    case "powerline":
      return `${baseOrgURL}/powerlines/${entityId}`
    case "group":
      return `${baseOrgURL}/device-groups/${entityId}`
    case "tower":
      return `${baseOrgURL}/towers/${entityId}`
    case "span":
      return `${baseOrgURL}/spans/${entityId}`
    case "device":
    default:
      return `${baseOrgURL}/devices/${entityId}`
  }
}
